exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-225d3514] {\n    margin: 7px;\n}\n", ""]);

// exports
